import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6c9e1984")

_pushScopeId("data-v-6c9e1984")
const _hoisted_1 = { class: "margin-left40px" }
const _hoisted_2 = { class: "display-flex" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_img_text = _resolveComponent("img-text")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_img_text, {
        onClick: _ctx.chooseActive,
        class: ['chooseType', _ctx.showFeaturePlan ? 'featureType' : ''],
        title: _ctx.ActiveType,
        img: require('@/assets/image/active.png')
      }, null, 8, ["onClick", "class", "title", "img"]),
      _createVNode(_component_img_text, {
        onClick: _ctx.chooseRenew,
        class: ['chooseType', _ctx.showFeaturePlan ? 'featureType' : ''],
        title: _ctx.$wordList.ProperAllTextRenew,
        img: require('@/assets/image/keepfee.png')
      }, null, 8, ["onClick", "class", "title", "img"]),
      (_ctx.showFeaturePlan)
        ? (_openBlock(), _createBlock(_component_img_text, {
            key: 0,
            onClick: _ctx.chooseFeature,
            class: ['chooseType', _ctx.showFeaturePlan ? 'featureType' : ''],
            title: _ctx.$wordList.ProperAllTextFeaturePlan,
            img: require('@/assets/image/featurePlan.png')
          }, null, 8, ["onClick", "class", "title", "img"]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.autoPayRecordComponent[_ctx.userType]), { onChangeStep: _ctx.changeStep }, null, 8, ["onChangeStep"]))
  ]))
})